<template>
  <h4>Products Page</h4>
</template>

<script>
export default {
  name: "ProductsPage",
};
</script>

<style>
</style>